"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlternateHrefLangLink = void 0;
var React = require("react");
/**
 * e.g. <link rel="alternate" hreflang="en-US" href="https://www.example.com/link" />
 */
var AlternateHrefLangLink = /** @class */function () {
  function AlternateHrefLangLink(hrefLang, href) {
    this.hrefLang = hrefLang;
    this.href = href;
  }
  AlternateHrefLangLink.prototype.renderMetaElement = function () {
    return React.createElement("link", {
      rel: "alternate",
      hrefLang: this.hrefLang,
      href: this.href
    });
  };
  return AlternateHrefLangLink;
}();
exports.AlternateHrefLangLink = AlternateHrefLangLink;